module.exports = __webpack_public_path__ + "img/icon2.a5796c5e.png";